/*
* Broadcast Theme
*
* NovaPrints storefront QA safeguards.
* Keep custom behavior isolated here so Broadcast updates remain maintainable.
*/

(function() {
  'use strict';

  let cartSyncTimer = null;
  let lastQuickAddTrigger = null;
  let lastSearchTrigger = null;

  function updateCartCountElements(itemCount) {
    document.querySelectorAll('cart-count, [data-cart-count]').forEach(function(countElement) {
      const limit = Number(countElement.getAttribute('data-limit'));
      const displayCount = limit && itemCount >= limit ? '9+' : String(itemCount);
      countElement.setAttribute('data-cart-count', String(itemCount));
      countElement.textContent = displayCount;
    });
  }

  function syncCartCount() {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    window.fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart sync failed');
        return response.json();
      })
      .then(function(cart) {
        updateCartCountElements(Number(cart.item_count) || 0);
      })
      .catch(function() {
        // Keep the native cart flow available if a third-party app blocks the refresh.
      });
  }

  function scheduleCartCountSync() {
    window.clearTimeout(cartSyncTimer);
    cartSyncTimer = window.setTimeout(syncCartCount, 120);
  }

  document.addEventListener('theme:product:add', scheduleCartCountSync);
  document.addEventListener('theme:cart:change', function(event) {
    if (!Number.isFinite(event.detail && event.detail.cartCount)) {
      scheduleCartCountSync();
    }
  });

  function rememberQuickAddTrigger(event) {
    const target = event.target instanceof Element ? event.target.closest('[data-quick-add-btn]') : null;
    if (target) lastQuickAddTrigger = target;
  }

  window.addEventListener('pointerdown', rememberQuickAddTrigger, true);
  window.addEventListener('mousedown', rememberQuickAddTrigger, true);

  window.addEventListener('click', function(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('[data-add-to-cart]')) {
      window.setTimeout(syncCartCount, 800);
      window.setTimeout(syncCartCount, 1800);
    }

    rememberQuickAddTrigger(event);

    const searchTrigger = target.closest('.navlink--search');
    if (searchTrigger) {
      lastSearchTrigger = searchTrigger;
    }

    if (target.closest('[data-popdown-close]') && lastSearchTrigger) {
      window.setTimeout(function() {
        if (lastSearchTrigger && lastSearchTrigger.isConnected) {
          lastSearchTrigger.focus({ preventScroll: true });
        }
        lastSearchTrigger = null;
      }, 80);
    }

  }, true);

  document.addEventListener('submit', function(event) {
    const form = event.target instanceof Element ? event.target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    window.setTimeout(syncCartCount, 800);
    window.setTimeout(syncCartCount, 1800);
  }, true);

  if (typeof MutationObserver === 'function') {
    new MutationObserver(function(records) {
      const quickAddRemoved = records.some(function(record) {
        return Array.from(record.removedNodes).some(function(node) {
          return node instanceof Element &&
            (node.matches('dialog[data-quick-add-modal]') || node.querySelector('dialog[data-quick-add-modal]'));
        });
      });

      if (!quickAddRemoved || !lastQuickAddTrigger) return;

      const returnFocus = lastQuickAddTrigger;
      lastQuickAddTrigger = null;
      window.setTimeout(function() {
        if (returnFocus.isConnected && typeof returnFocus.focus === 'function') {
          returnFocus.focus({ preventScroll: true });
        }
      }, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

})();
